<template>
  <v-dialog v-model="visivel" persistent max-width="800px">
    <v-card>
      <v-toolbar color="cyan" flat dark>
        <v-toolbar-title>
          <v-card-title>Detalhes</v-card-title>
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-card elevation="2" class="mb-3 mt-3">
          <v-card-title> Texto </v-card-title>
          <v-card-text>
            {{ item.texto }}
          </v-card-text>
        </v-card>
        <v-card v-if="mostrarArquivos" elevation="2" class="mb-3">
          <v-card-title> Anexos </v-card-title>
          <v-list dense v-if="mostrarArquivos">
            <v-list-item
              v-for="arquivo in item.arquivos"
              :key="arquivo.id"
              link
              @click="downloadArquivo(arquivo)"
            >
              <v-list-item-title>{{ arquivo.nome }}</v-list-item-title>
              <v-list-item-action>
                <v-icon color="blue"> mdi-download </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn color="orange lighten-3" @click="fechar"> Fechar </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as ArquivoService from "@/services/arquivo.service";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    visivel: {
      type: Boolean,
      required: true,
    },
    mostrarArquivos: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    fechar() {
      this.$emit("fechar");
    },
    downloadArquivo(arquivo) {
      ArquivoService.getOne(arquivo.id).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", arquivo.nome);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
  },
};
</script>